import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaUser, FaShoppingCart, FaMapMarkerAlt } from "react-icons/fa";
import "../navbar/NavBar.css";
import logo from "../component/img/log2.png";

export default function NavBar({ userEmail, onLogout, onCartClick }) {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        if (!userEmail) {
          const savedCart = localStorage.getItem("guest_cart");
          const guestCart = savedCart ? JSON.parse(savedCart) : [];
          setCartItems(guestCart);
          console.log("Loaded Guest Cart:", guestCart);
          return;
        }

        const response = await fetch(
          `https://yaasaai.com/myphpapi/getcartdata.php?phoneNumber=${encodeURIComponent(
            userEmail
          )}`
        );

        if (!response.ok) {
          console.error("Failed to fetch cart data:", response.status);
          return;
        }

        const data = await response.json();
        console.log("Cart API Response:", data);

        if (Array.isArray(data)) {
          setCartItems(data);
          localStorage.setItem(`cart_${userEmail}`, JSON.stringify(data));
        } else {
          console.error("Unexpected API response:", data);
          setCartItems([]);
        }
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    fetchCartData();
    const intervalId = setInterval(fetchCartData, 500);

    return () => clearInterval(intervalId);
  }, [userEmail]);

  const totalItemsInCart = cartItems.length;
  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/");
  };
  const handleLocationClick = () => {
    navigate("/location");
  };
  const handleCartClick = () => {
    if (userEmail) {
      if (onCartClick) onCartClick();
      navigate("/cart");
    } else {
      navigate("/");
    }
  };

  return (
    <Navbar
      expand={false} // disables collapsine
      variant="dark"
      className="navbar-custom fixed-top shadow-sm py-2"
    >
      <Container
        fluid
        className="d-flex flex-wrap justify-content-between align-items-center px-3"
      >
        {/* Logo and Brand */}
        <div
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
          className="d-flex align-items-center text-white fw-bold"
        >
          <img
            src={logo}
            alt="logo"
            title="YaaSaai online vegetables and fruits"
            style={{ width: "110px", height: "40px", marginTop: "10px" }}
          />
          {/*<span className="fs-5">YaaSaai</span>*/}
        </div>

        {/* Menu Items */}
        <div className="d-flex flex-wrap gap-3 mt-0 mt-lg-0">
          {/* Profile Dropdown */}
          <NavDropdown
            title={
              <>
                <FaUser size={16} className="me-1" />
                <span className="span">
                  {userEmail ? userEmail : "Profile"}
                </span>
              </>
            }
            id="profileDropdown"
            align="start"
            className="text-white"
          >
            {userEmail ? (
              <>
                <NavDropdown.Item onClick={() => navigate("/userorder")}>
                  My Orders
                </NavDropdown.Item>
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </>
            ) : (
              <NavDropdown.Item onClick={() => navigate("/")}>
                Sign Up
              </NavDropdown.Item>
            )}
          </NavDropdown>

          {/* Location Button 
          <Nav.Link
            onClick={handleLocationClick}
            className="text-white d-flex align-items-center"
          >
            <FaMapMarkerAlt size={16} className="me-1 blinking-icon" />
            <span className="span">Location</span>
          </Nav.Link>
          */}

          {/* Cart Button */}
          <Nav.Link
            onClick={handleCartClick}
            className="text-white position-relative d-flex align-items-center"
          >
            <FaShoppingCart size={16} className="me-1" />
            <span className="span">Cart</span>
            {totalItemsInCart > 0 && (
              <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-circle">
                {totalItemsInCart}
              </span>
            )}
          </Nav.Link>
        </div>
      </Container>
    </Navbar>
  );
}
